import { endOfMonth as endOfMonthFns } from 'date-fns';

export default function endOfMonth(date: Date): Date {
  return endOfMonthFns(date);
}
